import React, {FC, useState} from "react"
import {IYesOrNo as IProps} from "./types";
import {idGen} from "../../services/utils";
import cls from '../atoms.module.scss'

const RadioButton: FC<IProps> = ({
    index,
    item,
    handleChange,
    savedFormData,
}) => {
    const [checked, setChecked] = useState(true);
    let generatedId = item.attribute_code + idGen();

    const handleChecking = () => {
        setChecked(false)
    }
    return (
        <div key={index} className={cls["signUp-position-relative"]}>
            <div onClick={handleChecking} className={cls["signUp-position-radio-flex"]}>
                {item.field_options.map((elem: { id: number, label: string }, elemI: number) => (
                    <div key={elemI}>
                        <input
                            onChange={(e) => handleChange(e, item.validation)}
                            type="radio"
                            id={generatedId}
                            name={item.attribute_code}
                            value={elem.id}
                            className={cls["signUp-position-no-input"]}
                            required={!!+item.is_required}
                            style={{ marginLeft: "0px" }}
                            // @ts-ignore
                            checked={(checked && savedFormData?.[item.attribute_code] === elem.id) || null}
                        />
                        <label htmlFor={generatedId}>{elem.label}</label>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default RadioButton;